var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("תלמידים רשומים להרצאה"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "v-select",
            {
              staticStyle: { width: "60%" },
              attrs: {
                dir: "rtl",
                label: "Text",
                options: _vm.users,
                filterable: true,
                clearable: true,
                reduce: (user) => user.Value,
                searchable: true,
                "close-on-select": true,
                placeholder: "חפש תלמיד מהרשימה",
              },
              on: { search: _vm.onSearchUsers },
              model: {
                value: _vm.userId,
                callback: function ($$v) {
                  _vm.userId = $$v
                },
                expression: "userId",
              },
            },
            [
              _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
                _vm._v("לא נמצא תלמיד"),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }